export enum DepartureCityId {
    Moscow = 2,
    Peterburg = 1,
}